import React from 'react'

function InfoBox({title,description,icon, className, onClick}) {
  return (
    <div 
      className={`info-box ${className || ''}`} 
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
    >
      <div className="icon-wrapper">{icon}</div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
    </div>
  )
}

export default InfoBox